export const getNombreProcedimiento = (procedimiento) => {
  const { codigoCobertura, nombreCobertura } = procedimiento;

  if (!codigoCobertura && !nombreCobertura) {
    return "N/A";
  }

  return nombreCobertura
    ? `(${codigoCobertura}) ${nombreCobertura}`
    : codigoCobertura || "N/A";
};

export const getNombrePrestador = (prestador) => {
  const { codigoPrestador, nombrePrestador } = prestador;

  if (nombrePrestador && codigoPrestador) {
    return `(${codigoPrestador}) ${nombrePrestador}`;
  }

  if (nombrePrestador && !codigoPrestador) {
    return nombrePrestador;
  }

  if (codigoPrestador && !nombrePrestador) {
    return codigoPrestador;
  }

  return "N/A";
};
